import React from 'react'

const CustomerTermsAndConditions = () => {
    return (
        <div>
            <div className="bg-[#F0FDF8] py-10 md:py-16 px-4">
                <div className="container mx-auto max-w-4xl">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center leading-tight">
                        Terms and Conditions
                    </h1>
                </div>
            </div>

            <div className="flex-grow container mx-auto pb-10 md:pb-16 px-4 sm:px-6">
                <div className="bg-white p-5 sm:p-8 md:p-12 max-w-4xl mx-auto">
                    <div>
                        <>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    These Terms and Conditions (“Terms”) govern your access to and use of the Maidly mobile application and related services (“Platform”), operated by Maidly (“we”, “our”, “us”). By accessing, registering on, or using the Maidly app, you agree to be bound by these Terms and our Privacy Policy.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>The Nature of Our Service</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly functions strictly as a Technology Platform and Marketplace. It is important to understand the specific roles we play—and the roles we do not play—in your household management.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. The Aggregator Model</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    We do not directly employ the maids, cooks, plumbers, or technicians found on this platform. Instead, we act as a specialized "Digital Bridge." Our primary service is the provision of a high-tech ecosystem that enables:
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Discovery:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Helping you find verified help in your specific pincode.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Vetting:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Performing background checks and skill assessments before allowing a professional onto the platform.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Facilitation:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Handling the scheduling, GPS tracking, and secure payment processing.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Independent Contractor Status</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Every professional you book through Maidly is an Independent Service Provider (ISP).</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>They are "Micro-Entrepreneurs" who use our platform to find work.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>They have the right to accept or decline service requests.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>They are responsible for the quality of their own craft, while we are responsible for the quality of the platform experience.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. The "Booking Contract"</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>When you click "Confirm Booking," you are entering into two separate agreements:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>With Maidly:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}For the use of the app, the customer support, and the secure payment gateway.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>With the Professional:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}For the physical execution of the task (the cleaning, the cooking, or the repair).</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Our Role as a Quality Moderator</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    While we are not the "employer," we act as a Quality Gatekeeper. To protect the integrity of the Maidly ecosystem, we:
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Monitor Performance:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We use your ratings and reviews to decide which professionals stay on the platform.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Standardize Pricing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We set "Market-Fair" rates so you don't have to negotiate prices at your doorstep.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Mediation:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If a job isn't done correctly, we don't just walk away. We provide a dispute resolution channel to help fix the situation, though the ultimate responsibility for the work lies with the ISP.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>E. Limitations of Tech</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    While we strive for 100% uptime, you acknowledge that the nature of mobile technology means we cannot guarantee that the app will always be error-free or that a professional will always be available in your area at the exact moment you need them.
                                </span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Nothing in these Terms shall be construed as creating an employer-employee relationship, agency, partnership, or joint venture between Maidly and any Service Professional.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>User Accounts &amp; Eligibility</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    To ensure a secure environment for both homeowners and domestic professionals, we maintain strict criteria for who can create and maintain an account on Maidly.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Legal Capacity and Age Requirements</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The 18+ Rule:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You must be at least 18 years of age and possess the legal authority to enter into a binding contract under the Indian Contract Act, 1872.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Residential Authority:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}By creating an account and booking a service, you represent that you are either the owner, authorized tenant, or legal occupant of the premises where the service is requested. You must have the authority to allow a third-party professional to enter the property.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Account Veracity and "Know Your Customer" (KYC)</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Accurate Profile:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You agree to provide a valid mobile number, a legitimate email address, and your real full name. Using aliases or "fake" profiles is strictly prohibited and will result in an immediate permanent ban.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Verification:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Maidly reserves the right to verify your identity at any time. This may include requesting a government-issued ID or validating your mobile number via OTP  to prevent fraudulent bookings.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Account Security &amp; Responsibility</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The "One-User-One-Account" Policy:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To maintain the integrity of our rating and safety system, users are prohibited from having multiple active accounts.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Credential Protection:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You are the sole custodian of your login credentials. Any activity, booking, or communication performed through your account is legally attributed to you.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Unauthorized Access:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you suspect your account has been compromised, you must notify our Security Team immediately. Maidly is not liable for any losses caused by unauthorized use of your account.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Account Standing and "Good Conduct"</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Eligibility is not a one-time check; it is an ongoing status. Your eligibility to use the app may be revoked if:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Professional Harassment:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You engage in any form of verbal, physical, or sexual harassment toward a service provider.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Bypassing the Platform:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You attempt to "poach" a professional by offering them a direct cash deal outside of the app to avoid platform fees.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Payment Defaults:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You have a history of failed payments, chargebacks, or fraudulent transaction attempts.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>High Cancellation Rate:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You consistently book and cancel services at the last minute, which disrupts the livelihoods of our service professionals.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>E. Termination of Eligibility</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    We reserve the "Right to Refuse Service." Maidly may, at its reasonable discretion and, where feasible, with prior notice, except in cases involving safety, fraud, or legal compliance, suspend or terminate your account if we believe your actions pose a risk to the safety of our professionals, the reputation of our brand, or the security of other users.
                                </span>
                            </p>
                            <p>
                                <strong>Why this matters for your app:</strong>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The "Poaching" Clause:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}In the maid/cook industry, customers often try to hire the worker directly after the first meeting. Including this in the "Eligibility" section gives you the legal right to ban those users.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Authority over Premises:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}This protects you if a "guest" or someone without permission calls a plumber to a house they don't own.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Behavioral Standards:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}It sets the tone that the worker’s safety is just as important as the customer’s safety.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>Booking &amp; Service Expectations</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    To make "Booking &amp; Service Expectations" more descriptive, you need to define the "Rules of Engagement." This section is designed to prevent "scope creep" and to ensure the service professional can actually do their job when they arrive.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Definition of Service Scope</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The "What You See is What You Get" Rule:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Each service category has a specific list of inclusions and exclusions clearly outlined in the app.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Extra Tasks:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Service professionals are strictly instructed to perform only the tasks listed in the confirmed booking. If you request additional tasks upon their arrival, the professional may:</span>
                                    <ul>
                                        <li style={{ fontWeight: 400 }}>
                                            <span style={{ fontWeight: 400 }}>Decline the additional work.</span>
                                        </li>
                                        <li style={{ fontWeight: 400 }}>
                                            <span style={{ fontWeight: 400 }}>Ask you to "Add a Task" via the app (which will adjust the final bill).</span>
                                        </li>
                                    </ul>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Direct Negotiations:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You are prohibited from negotiating "side deals" or private task lists with the professional. All work must be recorded through the Maidly interface.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Preparedness and Access</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The 15-Minute Grace Period:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Professionals will wait for a maximum of 15 minutes at your doorstep. If you do not provide access within this window, the booking will be marked as a "Customer No-Show," and a cancellation fee will be charged to compensate the worker for their travel and lost time.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Entry Instructions:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You must provide clear instructions for entry. If a professional is denied entry by your building’s security because you failed to provide authorization, the responsibility lies with you.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. The Working Environment</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Professional Safety: You agree to provide a work environment that is safe and free from hazards. This includes:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Pet Management:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Aggressive or large pets must be secured in a separate room for the duration of the service.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Utilities:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You must ensure that necessary utilities (water, electricity, adequate lighting) are available for the professional to complete the task.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Climate:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}While not mandatory, providing a reasonably ventilated or cooled environment is expected for labor-intensive tasks like deep cleaning or cooking.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Dignity of Labor:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Maidly has a Zero-Tolerance Policy for verbal abuse, discrimination, or any form of demeaning behavior toward our professionals.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Materials and Equipment</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Who Provides What?:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Cleaning:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Standard cleaning includes basic chemicals. Heavy machinery or specialized ladders must be requested in advance.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Cooking:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You are responsible for providing all raw materials (groceries, spices, oil) and a functional kitchen.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Repairs:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}For plumbing or electrical work, the professional provides the tools, but the cost of "Consumables" (pipes, wires, taps) is borne by the customer, either through the app or by reimbursement with a valid receipt.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>E. The "Check-In" and "Check-Out" Process</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Verification:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To ensure accuracy, the professional will "Check-In" via GPS when they arrive and "Check-Out" when they finish.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Immediate Review:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We highly recommend that you inspect the work before the professional leaves. If you are unsatisfied, point it out immediately so they can rectify it on the spot. Once a professional has checked out, any new issues must be raised through a formal "Dispute" in the app within 24 hours.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>


                            <p><strong>Payments, Fees, and Taxes</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    By using Maidly, you agree to our standardized payment protocols. This system is designed to ensure that professionals are paid fairly and customers are charged accurately without the need for cash negotiations.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Pricing Structure and Estimates</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The "Total Service Fee":</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The price displayed at the time of booking consists of the Professional’s base rate, the Maidly platform fee, and applicable government taxes (GST).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Dynamic Pricing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Rates may vary based on peak demand hours, weekend surcharges, or the specific expertise level of the professional.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Quotes vs. Final Bills:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}For repair services (Plumbing/Electrical), the app provides an initial estimate. The final bill may be adjusted if the professional discovers hidden complexities upon arrival. You will be notified of any price change before the additional work begins.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. The "No-Cash" Integrity Policy</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>In-App Payments Only:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To maintain the safety and warranty of your service, all payments must be processed through our secure integrated payment gateway (UPI, Credit/Debit Cards, Net Banking).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Prohibition of "Direct Tipping":</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}While you may tip a professional for excellent service, this should ideally be done through the app’s tipping feature.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Cash-on-Delivery (COD):</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If COD is available in your region, it is strictly for the exact amount shown on the digital invoice. Paying extra or "off-book" to a worker is a violation of these terms and voids any platform insurance or damage claims.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Payment Authorization and "Holds"</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Pre-Authorization "Hold":</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}When you book a service, we may place a temporary authorization hold on your payment method for the estimated amount. This is not a charge; it ensures the funds are available.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Completion of Charge:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The actual deduction occurs only after the professional "Checks-Out" and the service is marked as completed.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Convenience &amp; Platform Fees</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Platform Fee:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Maidly charges a non-refundable "Convenience Fee" for every transaction. This fee covers background verification costs, 24/7 customer support, and the maintenance of the digital ecosystem.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Service Surcharges:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Additional fees may apply for "Emergency" bookings (service within 2 hours) or for services requested late at night.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>E. Taxes and Statutory Compliance</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>GST Compliance:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}In accordance with Indian Tax Laws, GST is applicable on both the service provided by the professional (if they meet the threshold) and the platform fee charged by Maidly.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Invoicing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A digital, tax-compliant invoice will be generated and sent to your registered email/app profile immediately upon service completion.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>F. Payment Failures and Arrears</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Outstanding Balances:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If a payment fails after a service has been rendered, Maidly reserves the right to automatically retry the payment method or restrict your account from making future bookings until the debt is cleared.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Debt Collection:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We reserve the right to seek legal remedies or use third-party collection agencies to recover significant unpaid balances.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>Cancellation &amp; Refund Policy</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    We understand that plans change. However, because our professionals block their schedules specifically for your booking, we have established a tiered cancellation system to ensure fair compensation for their time and travel. Maidly shall not be liable for any failure or delay in performance resulting from causes beyond its reasonable control, including but not limited to acts of God, natural disasters, government restrictions, internet failures, labor disputes, or pandemics.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Customer-Initiated Cancellations</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The "Grace Period":</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Cancellations made within 15 minutes of booking are free of charge, provided the professional has not already started their journey to your location.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Standard Cancellation:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}More than 24 hours notice: Full refund of any pre-paid amounts (minus a small processing fee if applicable).<br />
                                        Between 2 and 24 hours notice: A flat "Cancellation Fee" (e.g., ₹99–₹249) will be charged to cover the administrative cost of rescheduling.<br />
                                        Less than 2 hours notice: A "Last-Minute Fee" (up to 50% of the base service fee) will be charged. This amount goes directly to the professional to compensate them for the lost slot in their workday.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>On-Door Cancellation:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you cancel while the professional is at your doorstep or if they are denied entry, the full base service fee is non-refundable.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Professional-Initiated Cancellations</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Platform Responsibility:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If a professional cancels or fails to show up, Maidly will first attempt to find a replacement within 60 minutes.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Refund Guarantee:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If we cannot find a replacement, you are entitled to:</span>
                                    <ul>
                                        <li style={{ fontWeight: 400 }}>
                                            <span style={{ fontWeight: 400 }}>A 100% refund of any pre-paid amount.</span>
                                        </li>
                                        <li style={{ fontWeight: 400 }}>
                                            <span style={{ fontWeight: 400 }}>A "Rescheduling Credit" added to your account as an apology for the inconvenience.</span>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Refund Processing &amp; Timelines</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Source Rule:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}All refunds are credited back to the original payment method (UPI, Credit Card, or App Wallet). We cannot refund via cash.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Settlement Time:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}While we initiate refunds immediately, it typically takes 5–7 business days for the amount to reflect in your bank account, depending on your bank's processing speed.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Quality-Based Refund Requests (The Service Guarantee)</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The 24-Hour Window:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you are unsatisfied with the quality of the service (e.g., the house isn't clean or the sink is still leaking), you must file a "Dispute" through the app within 24 hours.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Investigation &amp; Rectification:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We do not offer "instant" refunds for quality issues.<br />
                                        Our first step is to send a professional back to rectify the issue at no extra cost.<br />
                                        If the issue cannot be fixed, a partial or full refund may be issued after an investigation by our Quality Assurance team.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>E. Non-Refundable Scenarios</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Refunds will not be issued if:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>The professional was unable to complete the task due to a lack of utilities (no water, no electricity).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>The customer provided the wrong address or contact details.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>The customer requested the professional to leave before the task was finished.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>Liability &amp; Property Damage</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    At Maidly, we take immense pride in the quality of our professionals. However, we recognize that accidents can happen. This section outlines the protocol and limitations regarding damages.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. The "Limited Liability" Clause</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Aggregate Role:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You acknowledge that Maidly is a technology platform and not the direct provider of the household services. Therefore, To the maximum extent permitted by applicable law, Maidly’s aggregate liability arising out of or related to any claim shall not exceed the amount paid by you for the specific service giving rise to such claim.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Direct Professional Liability:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The Service Professional is an independent contractor and is personally liable for any intentional or negligent damage they cause. We will assist you in providing the professional’s verified details should you choose to pursue a legal claim against them directly.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Reporting Damage (The 24-Hour Rule)</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Immediate Notice:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Any claim of property damage must be reported to our support team via the app or email within 24 hours of the service completion.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Evidence Requirements:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To process a claim, you must provide:</span>
                                    <ul>
                                        <li style={{ fontWeight: 400 }}>
                                            <span style={{ fontWeight: 400 }}>High-quality photographs/videos of the damage.</span>
                                        </li>
                                        <li style={{ fontWeight: 400 }}>
                                            <span style={{ fontWeight: 400 }}>Proof of the original value of the item (if requested).</span>
                                        </li>
                                        <li style={{ fontWeight: 400 }}>
                                            <span style={{ fontWeight: 400 }}>A description of how the damage occurred.</span>
                                        </li>
                                    </ul>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Failure to Report:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Any claims made after the 24-hour window will be considered void, as we cannot verify if the damage occurred during our service or afterward.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Exclusions from Liability</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Maidly and its professionals will not be held liable for:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Pre-existing Damage:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Issues that were already present but discovered during the service (e.g., a pipe that was already rusted and broke during a standard repair).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Fragile/High-Value Items:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Damage to items that were not secured by the customer, such as loose jewelry, cash, antiques, or electronics left in high-traffic work areas.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Incorrect Materials:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Damage caused by cleaning chemicals or materials provided by the Customer (e.g., if you provide a harsh chemical that stains your own marble).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Indirect Losses:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We are not liable for "consequential damages," such as loss of profit, loss of data, or emotional distress resulting from a service mishap.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. The Service Guarantee and Rectification</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>First Right of Repair:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}In the event of minor damage or poor service quality, Maidly reserves the right to send a different specialized professional to repair or rectify the issue at our expense before any monetary compensation is discussed.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Third-Party Repairs:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you hire an outside technician to fix a problem before notifying us, you waive your right to any refund or compensation from Maidly.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>E. Theft and Criminal Activity</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Zero Tolerance:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We maintain a zero-tolerance policy for theft. All our professionals undergo Aadhaar-based background checks and police verification.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Legal Protocol:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}In the rare event of a suspected theft, you must file a First Information Report (FIR) with the local police. We will cooperate fully with law enforcement and provide all available GPS and identity data of the professional to assist the investigation.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>F. Dispute Resolution &amp; Arbitration</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>In the event of any dispute, controversy, or claim arising out of or relating to these Terms or the use of the Platform, the parties shall first attempt to resolve the matter amicably.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>If the dispute is not resolved within 30 days. The arbitration shall be conducted by a sole arbitrator appointed by Maidly. Courts located in Jaipur, Rajasthan shall have exclusive jurisdiction for interim or injunctive relief. The seat of arbitration shall be India, and the language of arbitration shall be English.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>Prohibited Conduct</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    To ensure the safety, dignity, and efficiency of our marketplace, all users must adhere to this Code of Conduct. Violation of any of these terms may result in immediate account suspension, permanent banning, and, where applicable, legal action.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Interaction with Service Professionals</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Zero-Tolerance for Harassment:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Any form of verbal abuse, physical threats, or sexual harassment toward a professional is strictly prohibited. This includes inappropriate comments, unwelcome physical contact, or the display of offensive materials in the workspace.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Discrimination:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You may not discriminate against professionals based on their race, religion, caste, gender, or origin. You cannot cancel a booking solely because of a worker's background.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Coercion:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You must not force or pressure a professional to perform tasks that are illegal, unsafe, or outside the agreed-upon scope of work (e.g., asking a maid to climb an unstable roof).</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Platform Integrity (The "Anti-Poaching" Rule)</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Circumventing the App:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You are strictly prohibited from soliciting a service professional to work for you privately "offline" to avoid the platform fee. This undermines the security, insurance, and vetting systems we provide.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Direct Payments:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Attempting to pay a worker directly via cash or personal UPI (unless specifically authorized as a COD booking) is prohibited.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Data Privacy:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You may not use the contact information of a professional (phone number/address) for any purpose other than the specific booking confirmed. Harassing a worker via private calls after a job is finished is a violation of law.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Fraudulent Activity</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Identity Misrepresentation:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You may not create accounts under false names or use another person’s payment methods without their explicit authorization.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Review Manipulation:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You are prohibited from threatening a professional with a "1-star rating" to extort free services or discounts. Similarly, posting fake reviews to damage a worker’s reputation is forbidden.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Multi-Accounting:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Creating multiple accounts to take advantage of "First-Time User" discounts or to bypass a previous ban is a breach of these terms.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Misuse of the Premises</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Illegal Activities:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You may not use the app to facilitate any illegal activity. If a professional observes illegal substances, weapons, or human trafficking on the premises, they are instructed to leave immediately and report the incident to the police and Maidly.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Hazardous Environments:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Knowingly inviting a professional into a home with structural hazards, contagious biohazards, or aggressive unsecured animals without prior disclosure is prohibited.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>E. Intellectual Property &amp; Tech Misuse</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Reverse Engineering:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You may not attempt to copy, modify, or "scrape" the data from the app for competitive or commercial purposes.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Spamming:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Using the in-app chat to send promotional links, spam, or phishing attempts to workers is strictly prohibited.</span>
                                </li>
                            </ul>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    All rights, title, and interest in and to the Maidly platform, including software, branding, logos, text, and content, are owned exclusively by Redqubes. Unauthorized use is strictly prohibited.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>Changes in law</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    As Maidly evolves to better serve our community, we may periodically update these Terms and Conditions. This section explains how those changes are communicated and when they become binding.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Right to Modify</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    We may update these Terms from time to time in accordance with applicable laws. Material changes will be notified to users prior to becoming effective. Changes may be driven by:
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Legal Compliance:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Updates to labor laws, data protection acts, or tax regulations.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Service Enhancements:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The introduction of new features, such as "Subscription Models" or "Insurance Protection Plans."</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Safety Protocols:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}New requirements for household entry or worker verification.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Notification of Changes</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    We are committed to transparency. If a change is material (meaning it significantly affects your rights or costs), we will notify you through at least one of the following channels:
                                </span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>In-App Notification:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A "What’s New" pop-up or banner when you next open the app.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Email/SMS:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}A direct message to your registered contact details.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Revision Date:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The "Last Updated" date at the top of the Terms and Conditions page will be changed accordingly.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Acceptance of Updated Terms</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Continued Use:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Your continued use of the app after the effective date of any changes constitutes your explicit acceptance of the new Terms.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Choice to Exit:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you do not agree with the updated Terms, your sole remedy is to stop using the platform and delete your account. Any bookings made before the update will be governed by the Terms that were in place at the time of the booking.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Frequency of Review</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    While we strive to notify you of major changes, we encourage you to review this page periodically. Minor clarifications or formatting changes that do not alter the legal substance of the agreement may be made without a formal announcement.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>Contact Us</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    If you have any questions, concerns, or feedback regarding these Terms, the App, or the services provided, you can contact Maidly through any of the following methods:
                                </span>
                            </p>
                            <p>
                                <strong>Email:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}support@redqubes.com</span>
                            </p>
                            <p>
                                <strong>Phone:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}+91 92576 52266</span>
                            </p>

                        </>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerTermsAndConditions